import CapitalValue from 'components/CapitalValue';
import FormattedDate from 'components/FormattedDate';
import {presetDimensions} from 'components/imaging/ResizedDasWebImage';
import Optional from 'components/Optional';
import TargetPropertyAttributes from 'components/TargetPropertyAttributes';
import PropertyDetailImages from 'lib/PropertyDetailImages';
import {isNZLocale} from 'lib/PropertyUtils';
import PropTypes from 'prop-types';
import {Component} from 'react';
import { Box, Grid as MuiGrid } from '@mui/material';
import {Grid, Item} from 'semantic-ui-react';
import './TargetProperty.scss';
import {PropertyEstimateContainer} from 'components/PropertyEstimate';
import {PropertyImageGalleryContainer} from 'components/PropertyImageGallery';
import RadiusFilters from 'components/commons/RadiusFilters';
import ActiveListingsFilter from 'components/FilterFields/ActiveListingsFilter';

export default class TargetProperty extends Component {
  static propTypes = {
    detail: PropTypes.object.isRequired,
    hideOwnerNamesForVic: PropTypes.bool.isRequired,
    pageContext: PropTypes.string.isRequired,
    comparableType: PropTypes.string,
    reportType: PropTypes.object.isRequired,
    showRadiusFilters: PropTypes.bool,
  };

  state = {currentIndex: 0};

  onIndexChange = (currentIndex) => {
    this.setState({currentIndex});
  };

  render() {
    let {detail, pageContext, hideOwnerNamesForVic, reportType: {value : reportType}, comparableType, showRadiusFilters} = this.props;
    const {currentIndex} = this.state;
    const {singleLineAddress, propertyId} = detail;
    const images = PropertyDetailImages.list(detail);

    const isNzRental = isNZLocale() && reportType === 'rental';

    return (
      <Item.Group className="target-property" style={{marginTop: 0}}>
        <Item>
          <PropertyImageGalleryContainer
              key={`target-property-gallery-${propertyId}`}
              currentIndex={currentIndex}
              images={images}
              objectContext="Target Property"
              pageContext={pageContext}
              propertyId={propertyId}
              resizeProps={{
                isResize: true,
                resizeDimensions: presetDimensions.PROPERTY_MEDIUM
              }}
              onIndexChange={this.onIndexChange}
          />
          <Item.Content>
            <Grid>
              <Grid.Row>
                <Grid.Column>
                  <MuiGrid container spacing={2}>
                    <MuiGrid item size={7.7}>
                      <h3 className="address"><Optional value={singleLineAddress}/></h3>
                    </MuiGrid>
                    {
                      showRadiusFilters &&
                        <MuiGrid item size={4.3}>
                          <RadiusFilters comparableType={comparableType} />
                        </MuiGrid>
                    }
                  </MuiGrid>
                  <MuiGrid container spacing={2}>
                    <MuiGrid item size={7.7}>
                      <Box sx={{ ml: '10px' }}>
                        {!isNzRental && (
                            <PropertyEstimateContainer/>
                        )}
                        {isNZLocale() && (
                            <CapitalValue capitalValue={detail.capitalValue}/>
                        )}
                        {isNZLocale() && (
                            <div className="capital-value-date-div">
                              <strong style={{marginRight: 10}}>CV Date</strong>
                              <FormattedDate className="capital-value-date" date={detail.capitalValueDate}/>
                            </div>
                        )}

                      </Box>
                      <TargetPropertyAttributes
                          detail={detail}
                          hideOwnerNamesForVic={hideOwnerNamesForVic}
                          pageContext={pageContext}
                      />
                    </MuiGrid>
                    <MuiGrid item size={4.3}>
                      <ActiveListingsFilter comparableType={comparableType} sx={{ mt: 1.5 }} />
                    </MuiGrid>
                  </MuiGrid>
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Item.Content>
        </Item>
      </Item.Group>
    );
  }
}
